<ngx-mat-select-search [(ngModel)]="filter" [placeholderLabel]="searchPlaceholder">
  <div class="mat-select-search-custom-header-content">
    <svg-icon key="search" fontSize="16px" />
  </div>
  <span ngxMatSelectSearchClear>
    <svg-icon key="close" fontSize="16px" />
  </span>
</ngx-mat-select-search>
